export function clamp(number, min, max) {
    if (max === void 0) { max = Number.MAX_VALUE; }
    return Math.min(Math.max(number, min), max);
}
